import React, {useEffect, useState} from 'react';
import "./Constants.css"
import Table from "../Table/Table";
import Service from "../../../API/Service";

const Constants = () => {
    const [securityData, setSecurityData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [searchText, setSearchText] = useState('');
    const entity = 'constants'

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await Service.getTables(entity, searchText);
                const content = response?.data?.content;
                setSecurityData(content);

                if (content.length > 0) {
                    setColumns(["code", "value", "title"]); // Получаем список ключей первого объекта
                }
            } catch (error) {
                console.error("Ошибка при загрузке данных:", error);
                setSecurityData([]);
            }
        };
        fetchData();
    }, [searchText]);

    return (
        <div className={"constants__wrap"}>
            <h1>Constants</h1>
            <Table
                entity={entity}
                info={securityData}
                columns={columns}
                setSearchText={setSearchText}
            />
        </div>
    );
};

export default Constants;